import React, { useEffect } from "react";

export const TermsAndConditionsSubsPDF = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      <div className="termsPage">
        <h1>TERMS & CONDITIONS ACCEPTED BY SUBSCRIBER</h1>

        <p className="mb-3">
          By submitting this form and proceeding with payment, I acknowledge and
          confirm the following
        </p>
        <ul>
          <li>
            <p>I confirm that I am the rightful owner of this account.</p>
          </li>
          <li>
            <p>
              I confirm that I am using my own credit/debit card for this
              transaction or have authorized access to use the card.
            </p>
          </li>
          <li>
            <p>
              I authorize <a href="https://waqarzaka.net/">waqarzaka.net</a> to
              charge my card for a monthly subscription.
            </p>
          </li>
          <li>
            <p>
              I understand that this is a non-refundable digital subscription,
              and no refund requests will be accepted after 24 hours of
              purchase.
            </p>
          </li>
          <li>
            <p>
              I agree to the platform’s Terms & Conditions and Privacy Policy.
            </p>
          </li>
          <li>
            <p>
              I understand that any form of misuse, account sharing, or
              reselling of platform content may result in permanent account
              suspension without eligibility for a refund.
            </p>
          </li>
          <li>
            <p>
              By checking the boxes and submitting payment, I confirm that I
              have read, understood, and agreed to all of the above conditions.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};
